(function($, App, Utils, Components) {
  'use strict';

  const logger = new Logger('Shuffle');

  Components.create('Shuffle', {

    Selectors: {
      element: '.shop',
      trigger: '.shuffle-toggler'
    },


  bindEvents: () => {


    $(Components.Shuffle.Selectors.trigger).on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('selected');

      var filter = [];
      $('button.selected').each(function() {
         filter.push($(this).data('group'))
      });

      $(`*[data-filter]`).addClass('hide');
      filter.forEach(function(element) {
        $(`*[data-filter='${element}']`).removeClass('hide');
      });


      if( !$(Components.Shuffle.Selectors.trigger).hasClass('selected') ) {
        $(`*[data-filter]`).removeClass('hide');
      }

    });

  },

  init: () => {
    Components.Shuffle.bindEvents();
  }

});

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);
